import {Organization} from './organization.model';

export class ObjectCache<T>{
  en: T[];
  es: T[];
  ar: T[];
  vi: T[];
}
